function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, Alert, DatePicker, Space, Modal, Image, notification } from "antd";
import { Row, Col, Container } from "react-bootstrap";
import Common from "../includes/Common";
import RegisterPatient from "./RegisterPatient";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";

var NewAppointment = function NewAppointment(_ref) {
  var _handler = _ref.handler,
      customerId = _ref.customerId;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormProcessing = _useState2[0],
      setIsFormProcessing = _useState2[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      successMessage = _useState6[0],
      setSuccessMessage = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showRegister = _useState8[0],
      setShowRegister = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      userOptions = _useState10[0],
      setUserOptions = _useState10[1];

  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setSuccessMessage('');
    setErrorMessage('');
    axios.post(Common.baseApiUrl + 'setappointment', {
      appointed_user_id: values.appointed_user_id,
      customer_id: values.customer_id,
      reason: values.reason,
      date: values.date,
      user_id: Common.currentUser.id
    }).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage("Rendez-vous enregistré avec succès");
        form.resetFields();

        _handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };

  useEffect(function () {
    form.setFieldsValue({
      customer_id: customerId
    });
    axios.get(Common.baseApiUrl + "getplatformusers/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setUserOptions([]);
        response.data.users.forEach(function (u) {
          setUserOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: u.firstname + " " + u.lastname,
              value: u.id
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 5
      });
    });
  }, [customerId]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h5", {
      children: "Prendre un nouveau rendez-vous"
    }), /*#__PURE__*/_jsxs(Form, {
      form: form,
      style: {
        color: '#EEE'
      },
      onFinish: onFinish,
      layout: "vertical",
      children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          message: errorMessage,
          type: "error",
          banner: true
        })
      }), successMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          message: successMessage,
          type: "success",
          banner: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "customer_id",
        label: "ID patient/T\xE9l\xE9phone",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {
          placeholder: "Entrez ID patient ou numero de t\xE9l\xE9phone"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "reason",
        label: "Motif",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {
          placeholder: "Entrez le motif ici"
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "date",
            label: "Date pr\xE9vue",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(DatePicker, {
              showTime: true,
              placeholder: "Choisir une date"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "appointed_user_id",
            label: "RDV  avec",
            children: /*#__PURE__*/_jsx(Select, {
              options: userOptions,
              placeholder: "Choisir un responsable"
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Form.Item, {
          children: /*#__PURE__*/_jsx(Button, {
            loading: isFormProcessing,
            type: "default",
            htmlType: "submit",
            children: /*#__PURE__*/_jsx("b", {
              children: "Cr\xE9er le rdv"
            })
          })
        }), /*#__PURE__*/_jsx(Form.Item, {
          children: /*#__PURE__*/_jsx(Button, {
            loading: isFormProcessing,
            onClick: function onClick() {
              setShowRegister(true);
            },
            style: {
              background: "#CE524F"
            },
            type: "primary",
            children: /*#__PURE__*/_jsx("b", {
              children: "Cr\xE9er un dossier m\xE9dical"
            })
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      open: showRegister,
      footer: null,
      centered: true,
      onCancel: function onCancel() {
        setShowRegister(false);
      },
      title: /*#__PURE__*/_jsx("b", {
        children: "Nouveau dossier m\xE9dical"
      }),
      width: {
        xs: '95%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '50%',
        xxl: '50%'
      },
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 7,
          sm: 8,
          children: /*#__PURE__*/_jsx(RegisterPatient, {
            handler: function handler() {
              setShowRegister(false);

              _handler();

              notification.success({
                message: "Ok!",
                description: "Opération résussie"
              });
            }
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5,
          sm: 4,
          children: /*#__PURE__*/_jsx(Image, {
            src: "/drawables/emr.png",
            preview: false,
            width: "90%"
          })
        })]
      })
    })]
  });
};

export default NewAppointment;